import React from "react";
import TeamDetailsPage from "../TeamDetails/TeamDetailsPageContainer";
import InitPage from "./Containers/InitPageContainer";
import HeadToHeadPage from "../HeadToHead/HeadToHeadPageContainer";
import E404Page from "./E404Page.jsx";
import RankingsPageContainer from "./Containers/RankingPageContainer";
import { Route, Switch } from "react-router-dom";
const MyResultsApp = () => (
  <section className="container-all">
    <div className="container-all__inner">
      <Route
        path="/results"
        render={({ match }) => (
          <Switch>
            <Route path={`${match.path}/error404`} component={E404Page} />
            <Route
              exact
              path={`${match.path}/:game/team/:teamId`}
              component={TeamDetailsPage}
            />
            <Route
              exact
              path={`${match.path}/:game/headToHead`}
              component={HeadToHeadPage}
            />
            <Route
              exact
              path={`${match.path}/:game`}
              component={RankingsPageContainer}
            />
            <Route exact path={`${match.path}`} component={InitPage} />
          </Switch>
        )}
      />
    </div>
  </section>
);

export default MyResultsApp;
